import { connect } from 'react-redux';

import { redeemCode } from '../pyc-redeem.actions';
import { ICodeCheckDispatchProps } from './code-check.types';
import { Dispatch } from 'types/dispatch';
import CodeCheck from './code-check.component';

const mapDispatchToProps = (dispatch: Dispatch): ICodeCheckDispatchProps => ({
    redeemCode: () => {
        dispatch(redeemCode());
    }
});

export default connect(null, mapDispatchToProps)(CodeCheck);
